import { render, staticRenderFns } from "./DisqualifierDetail.vue?vue&type=template&id=6b366a12"
import script from "./DisqualifierDetail.vue?vue&type=script&lang=js"
export * from "./DisqualifierDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports